{
    "title": "page.findus.title",
    "components": [
        {
            "type": "tabs",
            "tabs": [
                {
                    "tab": "page.findus.llanishen.tab",
                    "children": [
                        {
                            "type": "row",
                            "id": "",
                            "children": [
                                {
                                    "type": "heading",
                                    "value": "page.findus.llanishen.title",
                                    "key": "7wy3D/RrQWCaXrFpodVZsw=="
                                },
                                {
                                    "type": "column",
                                    "width": 3,
                                    "children": [
                                        {
                                            "type": "text",
                                            "value": "67 Thornhill Road",
                                            "key": "C98kERs6T/+qJfqEG3q/Mw=="
                                        },
                                        {
                                            "type": "text",
                                            "value": "Llanishen",
                                            "key": "3oYs8GK+RhWVHuDexA0d/A=="
                                        },
                                        {
                                            "type": "text",
                                            "value": "CF14 6PE",
                                            "key": "w/zaZTlYQCCR2DgxIvtMFw=="
                                        },
                                        {
                                            "type": "text",
                                            "value": "page.findus.llanishen.phone",
                                            "key": "BhMH06haSI2l/68d0XuGVA=="
                                        }
                                    ],
                                    "key": "Nw92WjU3SnCwQlIf3GQIGg=="
                                },
                                {
                                    "type": "column",
                                    "width": 3,
                                    "children": [
                                        {
                                            "type": "text",
                                            "value": "page.findus.llanishen.freephone",
                                            "key": "HPHbL1agR2qU3isLB4QIpg=="
                                        },
                                        {
                                            "type": "text",
                                            "value": "page.findus.llanishen.weekdayopeningtimes",
                                            "key": "gJFGLJJ/R0G7q2a+0mpkig=="
                                        },
                                        {
                                            "type": "text",
                                            "value": "page.findus.email",
                                            "markdown": true,
                                            "key": "3Z9Z9Q6tQ7q6Z9Z9Q6tQ7w=="
                                        }
                                    ],
                                    "key": "FUU9ZUm9T/Gs2KSTphcOaQ=="
                                },
                                {
                                    "type": "column",
                                    "width": 6,
                                    "children": [
                                        {
                                            "type": "text",
                                            "value": "page.findus.alternative",
                                            "markdown": true,
                                            "key": "vf1uqOd7QIKIlZJ78DelmQ=="
                                        }
                                    ],
                                    "key": "j0WjsgWHTbSVXhwdCt4WsQ=="
                                }
                            ],
                            "key": "zYhO/g/GS2aa0gqzADuDrg=="
                        },
                        {
                            "type": "row",
                            "id": "",
                            "children": [
                                {
                                    "type": "column",
                                    "width": 6,
                                    "children": [
                                        {
                                            "type": "map",
                                            "id": "lisvane_map",
                                            "coordinates": "!1m14!1m8!1m3!1d1241.2334139350812!2d-3.200132!3d51.522997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9fe89ad7f039c685!2sInsync+Health+Llanishen!5e0!3m2!1sen!2suk!4v1487075661139",
                                            "key": "5bymtDWYRKGORzwnjv8few=="
                                        }
                                    ],
                                    "key": "0w1FayXuS4+TWfNC4VOR6A=="
                                },
                                {
                                    "type": "column",
                                    "width": 6,
                                    "children": [
                                        {
                                            "type": "checklist",
                                            "id": "lisvane_services",
                                            "items": [
                                                {
                                                    "value": "page.findus.llanishen.services.s1",
                                                    "key": "LOOwN1JpRyaAJDT5GSToog=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s2",
                                                    "key": "BU4U4wHDQ+mMDyHBKgnOwA=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s3",
                                                    "key": "rFw62sQuSeC8Q31WKYLVvw=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s4",
                                                    "key": "h209hO+fQeW7+J290X6wFA=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s5",
                                                    "key": "+4Iju/DOQxmL0aS8gsXYow=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s6",
                                                    "key": "NLA30oiVQLW3JCD8wPgVZg=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s7",
                                                    "key": "QHFU0UTzTBqx0UkpnOb8xg=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s8",
                                                    "key": "uLngtJ4YQciWg3WKJT1zag=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s10",
                                                    "key": "WpcHNsWLQJO2ok6ACbfLfA=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s12",
                                                    "key": "FDnktv/iTcyFRDEpi0Voyg=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s13",
                                                    "key": "6TF2mb+ETbyLbLRqBmNnBA=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s14",
                                                    "key": "SkCNVYHBQVqTixm9ofVYgg=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s15",
                                                    "key": "uazReHR7StWFH8vrjLKnLg=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s16",
                                                    "key": "WpznnxRxR0qR0smOZaOUmg=="
                                                },
                                                {
                                                    "value": "page.findus.llanishen.services.s17",
                                                    "key": "6IwWLMFKQjKCSadonGcfcA=="
                                                }
                                            ],
                                            "key": "CSoc9LymRgeKoHQzR74z3w=="
                                        }
                                    ],
                                    "key": "JUymjObiSpOQLQ1FGaHBBw=="
                                }
                            ],
                            "key": "BKgnBufvQ6C1iSiV/NPPvw=="
                        },
                        {
                            "type": "row",
                            "id": "",
                            "children": [
                                {
                                    "type": "column",
                                    "width": 6,
                                    "children": [
                                        {
                                            "type": "image",
                                            "image": "NHS_Wales_logo.jpg",
                                            "class": "nhs-wales-logo",
                                            "key": "rq6jiv0mQ66Epn/o6JdYBA=="
                                        }
                                    ],
                                    "key": "jYavyOf0QcGhE0HIcMhTkw=="
                                }
                            ],
                            "key": "w0hKRAMFTlK5r6tKMWpP9A=="
                        }
                    ],
                    "key": "DaShaavrRfq03kMX31Dsvw=="
                },
                {
                    "tab": "page.findus.thornhill.tab",
                    "children": [
                        {
                            "type": "row",
                            "id": "",
                            "children": [
                                {
                                    "type": "heading",
                                    "value": "page.findus.thornhill.title",
                                    "bold": true,
                                    "key": "HJ2dk8mznUyRp7vF9LqX4w"
                                },
                                {
                                    "type": "column",
                                    "width": 3,
                                    "children": [
                                        {
                                            "type": "text",
                                            "value": "North Cardiff Medical Centre",
                                            "key": "YW5kB7tPnEKcx4jS2vQm8A"
                                        },
                                        {
                                            "type": "text",
                                            "value": "Excalibur Drive",
                                            "key": "Kj9nM4wRtUyXp2vB5hLq7A"
                                        },
                                        {
                                            "type": "text",
                                            "value": "Thornhill",
                                            "key": "Zt6mH8kNbUyWx3vF9cQp4A"
                                        },
                                        {
                                            "type": "text",
                                            "value": "Cardiff",
                                            "key": "Qw5rT9yKmUyVn7vB2hXj4A"
                                        },
                                        {
                                            "type": "text",
                                            "value": "CF14 9BB",
                                            "key": "Gf8dL3pNbUyWx4vH6mQk9A"
                                        }
                                    ],
                                    "key": "Xc2wR7tKnUyVp5vB9hMq4A"
                                },
                                {
                                    "type": "column",
                                    "width": 3,
                                    "children": [
                                        {
                                            "type": "text",
                                            "value": "page.findus.thornhill.freephone",
                                            "key": "Bm4nK8wPtUyXp2vF7hLq3A"
                                        },
                                        {
                                            "type": "text",
                                            "value": "page.findus.thornhill.weekdayopeningtimes",
                                            "key": "Ry6cH9kNbUyWx4vB5mQj8A"
                                        },
                                        {
                                            "type": "text",
                                            "value": "page.findus.thornhill.sundayopeningtimes",
                                            "key": "Vt3mL7pKnUyXw2vF8hQc4A"
                                        },
                                        {
                                            "type": "text",
                                            "value": "page.findus.email",
                                            "markdown": true,
                                            "key": "Jf9wR4tMbUyVp5vB2hNk7A"
                                        }
                                    ],
                                    "key": "Zx5cK8nPtUyWx3vF6mLq2A"
                                },
                                {
                                    "type": "column",
                                    "width": 6,
                                    "children": [
                                        {
                                            "type": "text",
                                            "value": "page.findus.alternative",
                                            "markdown": true,
                                            "key": "Qm7dH2wKbUyXp4vB9nRt5A"
                                        }
                                    ],
                                    "key": "Nh3cL6pMtUyVw8vF4hQk7A"
                                }
                            ],
                            "key": "Wy5mK9nRbUyXp2vB7hLq4A"
                        },
                        {
                            "type": "row",
                            "id": "",
                            "children": [
                                {
                                    "type": "column",
                                    "width": 6,
                                    "children": [
                                        {
                                            "type": "map",
                                            "id": "thornhill_map",
                                            "coordinates": "!1m14!1m8!1m3!1d9926.630681775378!2d-3.194616!3d51.5378384!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x486e1c0c78977761%3A0x406c381d549401d3!2sNorth%20Cardiff%20Medical%20Centre!5e0!3m2!1sen!2suk!4v1732571048264!5m2!1sen!2suk",
                                            "key": "Gf4wR8tKnUyVp3vB6hMq9A"
                                        }
                                    ],
                                    "key": "Xc7dL2pNbUyWx5vF9hQk4A"
                                },
                                {
                                    "type": "column",
                                    "width": 6,
                                    "children": [
                                        {
                                            "type": "checklist",
                                            "id": "thornhill_services",
                                            "items": [
                                                {
                                                    "value": "page.findus.thornhill.services.s1",
                                                    "key": "Bm5nK8wPtUyXp2vF7hLq3A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s2",
                                                    "key": "Ry9cH4kNbUyWx6vB5mQj8A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s3",
                                                    "key": "Vt2mL7pKnUyXw3vF8hQc4A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s4",
                                                    "key": "Jf6wR4tMbUyVp5vB2hNk7A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s5",
                                                    "key": "Zx8cK3nPtUyWx4vF6mLq2A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s6",
                                                    "key": "Qm5dH9wKbUyXp7vB8nRt5A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s7",
                                                    "key": "Nh4cL6pMtUyVw2vF3hQk7A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s8",
                                                    "key": "Wy7mK2nRbUyXp5vB9hLq4A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s10",
                                                    "key": "Gf3wR8tKnUyVp6vB4hMq9A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s13",
                                                    "key": "Bm9nK4wPtUyXp3vF6hLq3A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s14",
                                                    "key": "Ry2cH7kNbUyWx5vB8mQj8A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s15",
                                                    "key": "Vt6mL3pKnUyXw4vF7hQc4A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s16",
                                                    "key": "Jf8wR5tMbUyVp2vB9hNk7A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s17",
                                                    "key": "Zx4cK7nPtUyWx6vF2mLq2A"
                                                },
                                                {
                                                    "value": "page.findus.thornhill.services.s18",
                                                    "key": "kjMJnPgLvEyRv0eaoR7ITQ=="
                                                }
                                            ],
                                            "key": "Qm2dH5wKbUyXp8vB4nRt5A"
                                        }
                                    ],
                                    "key": "Nh7cL9pMtUyVw3vF6hQk7A"
                                }
                            ],
                            "key": "Wy4mK6nRbUyXp5vB8hLq4A"
                        },
                        {
                            "type": "row",
                            "id": "",
                            "children": [
                                {
                                    "type": "column",
                                    "width": 6,
                                    "children": [
                                        {
                                            "type": "image",
                                            "image": "NHS_Wales_logo.jpg",
                                            "class": "nhs-wales-logo",
                                            "key": "Gf2wR7tKnUyVp4vB9hMq9A"
                                        }
                                    ],
                                    "key": "Xc8dL3pNbUyWx6vF5hQk4A"
                                }
                            ],
                            "key": "Bm5nK9wPtUyXp2vF7hLq3A"
                        }
                    ],
                    "key": "Ry3cH6kNbUyWx4vB8mQj8A"
                }
            ],
            "key": "Vt7mL2pKnUyXw5vF9hQc4A"
        }
    ],
    "key": "8NrP4IlISNuKYLOQd4o8ig=="
}